import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { Spin } from "antd";

import { PATHS } from "../constants/paths";
import {
  getAuthenticatedUser,
  getTokenValidStatus,
} from "../helpers/auth/auth";
import { AuthContext } from "../context/AuthContext";

const NotFoundPath = () => {
  const {
    state: { homePath, loadingUserAccess },
  } = useContext(AuthContext);

  const authenticatedUser = getAuthenticatedUser();
  const isValidToken = getTokenValidStatus();

  const notFoundAnyAccess = (
    <div className="text-center text-danger fw-bold fs-4 py-4">
      <p>ليس لديك أي صلاحية حاليا</p>
    </div>
  );

  if (authenticatedUser && isValidToken && homePath) {
    return <Navigate to={homePath} />;
  } else if (
    authenticatedUser &&
    isValidToken &&
    !homePath &&
    !loadingUserAccess
  ) {
    return notFoundAnyAccess;
  } else if (authenticatedUser && isValidToken) {
    return <Spin />;
  } else if (authenticatedUser && !isValidToken) {
    return <Navigate to={PATHS.validate2fa} />;
  } else {
    return <Navigate to={PATHS.login} />;
  }
};

export default NotFoundPath;
